<template>
  <div class="flex flex-none flex-row justify-center items-center rounded-lg px-2 py-1" :class="{ [status.couleur]: true}">
    <span class="text-white w-auto">{{status.text}}</span>
  </div>
</template>

<script setup>

import {computed, defineProps} from "vue";
import {enumeration} from "../../../Enumeration";
import {t} from "@/utils/Traduction";

const props = defineProps({
  statut: {
    type: String,
    required: true,
  },
});

const status = computed(() => {
  let text = "";
  let couleur = "";

  switch (props.statut) {
    case enumeration.statusPrinter.OPERATIONAL:
    case enumeration.statusPrinter.READY:
      text = t("ready");
      couleur = "bg-primary";
      break;
    case enumeration.statusPrinter.PRINTING:
      text = t('printing');
      couleur = "bg-green-500";
      break;
    case enumeration.statusPrinter.PAUSED:
    case enumeration.statusPrinter.PAUSING:
      text = t('paused');
      couleur = "bg-orange-700";
      break;
    case enumeration.statusPrinter.ERROR:
    case enumeration.statusPrinter.CLOSEDORERROR:
      text = t('error')
      couleur = "bg-red-500";
      break;
    case enumeration.statusPrinter.CANCELLING:
    default:
      text = props.statut;
      couleur = "bg-gray-500";
  }

  return { text, couleur };
});

</script>

<style scoped>

</style>